import { PerspectiveCamera, Vector3 } from "three";
import type { SceneTransform, Vector3Value } from "@/types/scene";

export type CameraPreset = "Front" | "Back" | "Left" | "Right" | "Top" | "Perspective" | "Close Up" | "Medium Shot" | "Wide Shot";

const presetPositions: Record<CameraPreset, Vector3Value> = {
  Front: { x: 0, y: 3, z: 10 }, Back: { x: 0, y: 3, z: -10 }, Left: { x: -10, y: 3, z: 0 }, Right: { x: 10, y: 3, z: 0 }, Top: { x: 0, y: 12, z: .01 }, Perspective: { x: 8, y: 6, z: 10 }, "Close Up": { x: 0, y: 2, z: 4 }, "Medium Shot": { x: 0, y: 3, z: 8 }, "Wide Shot": { x: 0, y: 6, z: 16 },
};

export function lookAtRotation(position: Vector3Value, target: Vector3Value = { x: 0, y: 1, z: 0 }): Vector3Value {
  const object = new PerspectiveCamera();
  object.position.set(position.x, position.y, position.z);
  object.lookAt(new Vector3(target.x, target.y, target.z));
  return { x: object.rotation.x, y: object.rotation.y, z: object.rotation.z };
}

export function cameraPresetTransform(preset: CameraPreset): Pick<SceneTransform, "position" | "rotation"> {
  const position = { ...presetPositions[preset] };
  return { position, rotation: lookAtRotation(position) };
}
